import { useGlobalContext } from "./context/globalContext";
import React, { useState, useRef, useEffect } from "react";
import {
  FaSchool,
  //   FaFilm,
  FaShoppingCart,
  // FaUtensils,
  FaHospitalSymbol,
} from "react-icons/fa";
import { FaMapLocation } from "react-icons/fa6";

const LocationBenefits2 = () => {
  const { handleShowModal } = useGlobalContext();
  const [activeDetail, setActiveDetail] = useState(null);
  const detailsRef = useRef(null);

  // Handle click outside to close details
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the details and the icon
      if (
        detailsRef.current &&
        !detailsRef.current.contains(event.target) &&
        !event.target.closest(".benefit-icon")
      ) {
        setActiveDetail(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle icon click
  const handleIconClick = (index, event) => {
    event.stopPropagation();
    setActiveDetail(activeDetail === index ? null : index);
  };
  const benefits = [
    {
      icon: <FaSchool />,
      title: "Education",
      details: [
        "Bombay Scottish Scl - 5mins",
        "Dhirubhai Ambani Intl. Scl - 15mins",
        "Arya Vidya Mandir - 10mins",
        "Stellar Intl - 15mins",
      ],
    },
    {
      icon: <FaHospitalSymbol />,
      title: "Hospitals",
      details: [
        "Fortis SL Raheja - 1min",
        "Hinduja Hospital - 5mins",
        "Lilavati Hospital - 8mins",
        "Asian Heart Hospital - 10mins",
      ],
    },

    {
      icon: <FaShoppingCart />,
      title: "Malls",
      details: [
        "Jio Drive-In - 7mins",
        "Palladium Mall - 12mins",
        "Phoenix Kurla - 18mins",
        "Bandra Hi-Street - 12mins",
      ],
    },
    {
      icon: <FaMapLocation />,
      title: "Connectivity",
      details: [
        "Mahim Station - 1min",
        "Bandra Station - 8mins",
        "Dadar Station - 10mins",
        "Western Express Hwy - 5mins",
        "Bandra Sea Link - 5mins",
        "Mumbai Airport - 20mins",
      ],
    },
  ];
  return (
    <>
      <div className="section shadow-sm lazyloaded">
        <div className="lb-container">
          <div className="lb-map">
            <img src="/images/lb.PNG" alt="Location Overview" />
          </div>
          <div className="lb-content">
            <div className="lb-content-body">
              <h2 className="head text-capitalize text-center">
                L&T Realty Island Cove - Location & Connectivity
              </h2>
              <div className="cards">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    className={`crd position-${index + 1}  ${
                      activeDetail === index ? "alive-card" : ""
                    } `}
                  >
                    <div
                      className="crd-icon"
                      onClick={(e) => handleIconClick(index, e)}
                    >
                      {benefit.icon}
                      <span className="crd-title">{benefit.title}</span>
                    </div>
                    <div
                      ref={activeDetail === index ? detailsRef : null}
                      className={`crd-details ${
                        activeDetail === index ? "active" : ""
                      }`}
                      id="card-details-scroll"
                    >
                      <ul>
                        {/* {benefit.details.map((detail, idx) => (
                          <li key={idx}>{detail}</li>
                        ))} */}
                        {benefit.details.map((detail, idx) => {
                          const parts = detail.split(" - "); // Using " - " (en dash) for separation
                          if (parts.length === 2) {
                            return (
                              <li key={idx}>
                                <span>{parts[0]}</span>
                                <span>{parts[1]}</span>
                              </li>
                            );
                          } else {
                            return <li key={idx}>{detail}</li>; // Handle cases with no " - "
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lb-content-footer">
              <span
                className="new-button"
                onClick={() => handleShowModal("Location Benefits")}
              >
                <span className="new-button-inner">
                  <span className="underline-animation">Get All Details</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocationBenefits2;
